import React from 'react';
import { useContent } from '../content/ContentContext';
import { Arrow, Check, Reveal, SectionHeader } from '../lib/ui';
import ConnectDiagram from './ConnectDiagram';

const statusClass: Record<string, string> = {
  soon: 'border-accent/40 bg-accent/10 text-accent',
  live: 'border-white/10 bg-white/[0.04] text-fg-2',
  request: 'border-white/10 bg-white/[0.04] text-fg-2',
};

const Solutions: React.FC = () => {
  const { solutions } = useContent();
  if (!solutions.visible) return null;

  return (
    <section id="loesungen" className="scroll-mt-20 border-t border-line py-24 md:py-32">
      <div className="container-site">
        <SectionHeader eyebrow={solutions.eyebrow} title={solutions.title} intro={solutions.intro} />

        <div className="mt-12 grid md:mt-20 md:gap-6 lg:grid-cols-2 lg:gap-8">
          {solutions.items.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={s.diagram ? 'lg:col-span-2' : ''}>
              <article className={`border-t border-line py-12 first:border-t-0 first:pt-0 md:card md:h-full md:overflow-hidden md:border-t-0 md:py-0 ${s.diagram ? 'md:grid lg:grid-cols-2' : ''}`}>
                <div className="flex h-full flex-col md:p-10 lg:p-12">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className={`chip ${statusClass[s.status] || ''}`}>
                      {s.status === 'soon' && <span className="h-1.5 w-1.5 rounded-full bg-accent" />}
                      {s.statusLabel}
                    </span>
                  </div>
                  <h3 className="mt-5 text-2xl font-semibold tracking-tight sm:text-3xl">{s.name}</h3>
                  <p className="mt-2 text-lg text-fg-2">{s.tagline}</p>
                  <p className="mt-5 text-[15px] leading-relaxed text-fg-2 sm:text-base">{s.description}</p>
                  <ul className="mt-6 space-y-3">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-3 text-[15px] text-fg">
                        <Check className="mt-0.5 h-5 w-5 shrink-0" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto pt-8">
                    <a href={s.cta.href} className={s.status === 'soon' ? 'btn-primary' : 'btn-secondary'}>
                      {s.cta.label} <Arrow />
                    </a>
                  </div>
                </div>
                {s.diagram === 'connect' && (
                  <div className="mt-8 flex items-center md:mt-0 md:border-t md:border-line md:bg-surface-2/40 md:p-8 lg:border-l lg:border-t-0 lg:p-10">
                    <div className="w-full"><ConnectDiagram /></div>
                  </div>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
